//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";

export default {
    name: "AddNewDynamicMember",
    components: {
        AQAvatar,
        AQCheckbox,
        AQTooltip
    },
    props: {
        parentId: {
            type: String,
            default: ""
        },
        parentIndex: {
            type: String,
            default: ""
        },
        selectParent: {
            type: Object,
            default: () => {}
        },
        selectedData: {
            type: Array,
            default: () => []
        },
        loadDefaultElementsNr: {
            type: Number, default: 0
        },
        resetDataFromStore: {
            type: [Boolean, String],
            default: false
        },
        addAllData: {
            type: [Boolean, String],
            default: false
        },
        addCustom: { type: Boolean, default: false },
        groupsToRemove: {
            type: Array,
            default: () => []
        },
        alreadySelectedMembers: {
            type: Array,
            default: () => []
        },
        enableAlreadySelected: {
            type: Boolean,
            default: false
        },
        fromProcessInspector: {
            type: Boolean,
            default: false
        },
        childMemberChange: {
            type: Boolean,
            default: false
        },
        hideSystemUsers: {
            type: Boolean,
            default: false
        },
        hiddenParents: {
            type: Array,
            default: () => []
        },
        displayAllAssignee: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpened: false,
            collapseBodyData: [],
            childrenSelectedData: [],
            selectAll: false,
            resetData: false,
            addData: false,
            versionControl: "",
            dataComp: [],
            disabledChecked: true,
            disabledUser: false,
            loading: false,
            // eslint-disable-next-line global-require
            defaultAvatar: require("@/assets/images/user.svg"),
            adminGroupUserIdDuplicated: "00000000-0000-0000-0000-000000000001", // hardcoded in backend
            systemTypeList: ["TSYS", "TOAUTHUSR", "TANON"]
        };
    },
    computed: {
        ...mapGetters("admin", ["getAllMembersData"])
    },
    watch: {
        selectParent: {
            handler(newValue) {
                this.checkIfParentSelected(newValue);
            }
        },
        resetDataFromStore: {
            handler(newValue) {
                if (newValue && newValue === this.parentId) {
                    this.childrenSelectedData.forEach(elemId => {
                        this.$store.commit("admin/removeSelectedMembers", elemId);
                    });
                    this.resetData = true;
                } else {
                    this.resetData = false;
                }
            },
            immediate: true
        },
        addAllData: {
            handler(newValue) {
                if (newValue && newValue === this.parentId) {
                    this.dataComp.forEach(elem => {
                        this.$store.commit("admin/addNewSelectedMembers", elem);
                    });
                    this.addData = true;
                } else {
                    this.addData = false;
                }
            },
            immediate: true
        },
        getAllMembersData: {
            handler(newValue) {
                if ((newValue[this.parentId] && this.parentId === "parent") || (newValue[this.parentId] && this.dataComp && !this.dataComp.length)) {
                    if (!this.hideSystemUsers) {
                        this.dataComp = newValue[this.parentId].filter(elem => !this.groupsToRemove.includes(elem.code));
                    } else {
                        this.dataComp = newValue[this.parentId].filter(elem => !this.systemTypeList.includes(elem.systemType)
                                                                                && !this.groupsToRemove.includes(elem.code));
                    }
                    if (this.enableAlreadySelected) {
                        this.setSelectedData(this.alreadySelectedMembers);
                    } else if (this.selectedData && this.selectedData.length) {
                        this.setSelectedData(this.selectedData);
                    }
                    this.checkIfParentSelected(this.selectParent);
                }
            },
            deep: true
        }
    },
    created() {
        this.$root.$on("clearAllMembers", () => {
            this.$store.commit("admin/removeSelectedMembers");
            this.$store.commit("admin/addNewMember");
            this.childrenSelectedData = [];
        });
        this.$root.$on("deleteMember", id => {
            if (this.childrenSelectedData && this.dataComp && this.dataComp.length) {
                const itemIndex = this.childrenSelectedData.indexOf(id);
                if (itemIndex !== -1) {
                    this.childrenSelectedData.splice(itemIndex, 1);
                    const elementToDelete = this.dataComp.find(elem => elem.id === id);
                    if (elementToDelete) {
                        this.addSelected(elementToDelete);
                    }
                }
            }
        });
        this.$root.$on("resetSelectedMembers", (data) => {
            if (data) {
                if (JSON.stringify(data) !== JSON.stringify(this.childrenSelectedData && this.dataComp && this.dataComp.length)) {
                    const itemsList = [...this.childrenSelectedData];
                    itemsList.forEach(id => {
                        const index = this.childrenSelectedData.indexOf(id);
                        this.childrenSelectedData.splice(index, 1);
                        const elementToRemove = this.dataComp.find(item => item.id === id || item.code === id);
                        if (elementToRemove) {
                            this.addSelected(elementToRemove);
                        }
                    });
                    data.forEach(id => {
                        this.childrenSelectedData.push(id);
                        const elementToBeAdded = this.dataComp.find(item => item.id === id || item.code === id);
                        if (elementToBeAdded) {
                            this.addSelected(elementToBeAdded);
                        }
                    });
                }
            }
        });
    },
    methods: {
        setSelectedData(data) {
            data.forEach(id => {
                const item = this.dataComp.find(element => element.id === id || element.code === id);
                if (item && !this.childrenSelectedData.includes(item.id)) {
                    this.childrenSelectedData.push(item.id);
                    this.$store.commit("admin/addNewSelectedMembers", item);
                }
            });
        },
        setItemType(item) {
            let type;
            if (item.type === "GROUP") {
                if (item.sourceType === "AD") {
                    type = "externalGroup";
                } else if (item.systemType === "APPLICATION") {
                    type = "applicationSpecific";
                } else {
                    type = "platform";
                }
            } else if (item.type === "USER") {
                if (item.systemType === "TOAUTHUSR") {
                    type = "systemExternalUser";
                } else if (item.systemType === "TSYS") {
                    type = "systemInternalUser";
                } else {
                    type = (item.sourceType === "AD" || item.systemType === "TSAMLUSR" || item.systemType === "TOPENIDUSR") ? "externalUser" : "userPlatform";
                }
            }
            return type;
        },
        checkIfDisabled(item) {
            return !this.enableAlreadySelected && (this.alreadySelectedMembers.includes(item.id) || this.alreadySelectedMembers.includes(item.code));
        },
        setImage(user) {
            return user && (user.avatar || user.avatarPath) ? `/identity/tenants/users/image/${user.id}/s` : null;
        },
        checkIfParentSelected(newValue) {
            if (newValue && newValue.id === this.parentId) {
                if (newValue.isSelected) {
                    this.selectAll = true;
                    this.childrenSelectedData = this.dataComp.map(element => element.id);
                } else {
                    this.selectAll = false;
                }
            }
        },
        openDetails(item) {
            const existingMember = this.getAllMembersData[item.id];
            this.loading = item.id;
            if (existingMember) {
                this.$store.commit("admin/addNewMember", { id: item.id, data: existingMember });
                this.isOpened = true;
                this.loading = null;
            } else {
                this.$store.dispatch("admin/getMemberGroupDetails", item.id).then(
                    data => {
                        // hide system users that are in a group when expanding the details
                        if (!this.displayAllAssignee) {
                            data = data.filter(elem => !this.systemTypeList.includes(elem.systemType));
                        }
                        data.forEach(element => {
                            element.parentId = this.parentId;
                            element.parentName = item.name || "";
                        });
                        this.$store.commit("admin/addNewMember", { id: item.id, data });
                        this.isOpened = true;
                        this.loading = null;
                    },
                    // eslint-disable-next-line no-unused-vars
                    error => {
                        this.showNotification(this.$t("admin.usersAndRoles.addGroupMembers.noMembersAvailable"));
                    }
                );
            }
        },
        addSelected(item) {
            if (item.type === "GROUP") {
                if (this.childrenSelectedData.includes(item.id)) {
                    this.resetData = item.id;
                    setTimeout(() => {
                        this.resetData = false;
                    }, 0);
                } else {
                    this.addData = item.id;
                    setTimeout(() => {
                        this.addData = false;
                    }, 0);
                }
            }
            if (this.selectAll) {
                this.selectAll = false;
                this.dataComp.forEach(element => {
                    this.$store.commit("admin/addNewSelectedMembers", element);
                });
                this.$store.commit("admin/removeSelectedMembers", this.parentId);
                this.$emit("uncheckParent", this.parentId);
            }
            if (this.parentId !== "parent" && this.dataComp.length === this.childrenSelectedData.length) {
                this.$emit("checkParent", this.parentId);
                this.childrenSelectedData.forEach(element => {
                    this.$store.commit("admin/removeSelectedMembers", element);
                });
            } else if (this.childrenSelectedData.includes(item.id)) {
                this.$store.commit("admin/addNewSelectedMembers", item);
            } else {
                this.$store.commit("admin/removeSelectedMembers", item.id);
            }
        },
        checkParent(id) {
            this.childrenSelectedData.push(id);
            const element = this.dataComp.find(childElem => childElem.id === id);
            this.$store.commit("admin/addNewSelectedMembers", element);
            if (this.childrenSelectedData.length === this.dataComp.length) {
                this.selectAll = true;
                this.childrenSelectedData.forEach(childSelect => {
                    this.$store.commit("admin/removeSelectedMembers", childSelect);
                });
                this.$emit("checkParent", this.parentId);
            }
        },
        uncheckParent(id) {
            this.childrenSelectedData = this.childrenSelectedData.filter(elem => elem !== id);
            this.$store.commit("admin/removeSelectedMembers", id);

            if (this.selectAll) {
                this.selectAll = false;
                const dataToSend = this.dataComp.filter(element => element.id !== id);
                this.$store.commit("admin/addNewSelectedMembers", dataToSend);
                this.$emit("uncheckParent", this.parentId);
            }
        },
        showNotification(message) {
            this.$toast.showNotify({
                type: "error",
                message
            });
        }
    }
};
